import { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";

const SessionChangeDialog = ({ open, onClose, onConfirm, title, message }) => {
    const [hasChanges, setHasChanges] = useState(false);

    useEffect(() => {
        // Check for session changes
        const flags = JSON.parse(sessionStorage.getItem("changeFlags") || "{}");
        const hasSessionChanges = Object.values(flags).some(Boolean);
        setHasChanges(hasSessionChanges);
    }, [open]);

    const handleConfirm = () => {
        if (hasChanges) {
            // Clear all flags
            sessionStorage.setItem(
                "changeFlags",
                JSON.stringify({
                    sequence: false,
                    contacts: false,
                    settings: false,
                })
            );
        }
        onConfirm();
    };

    const handleCancel = () => {
        onClose();
    };

    // If no changes, proceed directly
    if (open && !hasChanges) {
        handleConfirm();
        return null;
    }

    return (
        <Dialog open={open && hasChanges} onClose={handleCancel} maxWidth="sm" fullWidth>
            <DialogTitle>
                {title || "Unsaved Changes"}
            </DialogTitle>
            <DialogContent>
                <Typography>
                    {message || "You have unsaved changes. Are you sure you want to continue?"}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleConfirm} variant="contained" color="primary">
                    Yes, Continue
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SessionChangeDialog; 